window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.eventRepo = function () {
    var url = 'api/event';

    var create = function (eventId, location) {
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify({
                casinoEvent: eventId,
                casinoLokacija: location
            })
        }).catch(casino.repos.base.handleNetworkException);
    };


    return {
        create: create
    }

}();